import WhatsAppLink from './WhatsAppLink'

const Contact = () => {
  return (
    <section id="contato" className="py-20 bg-gradient-to-b from-[#f8f9fc] to-white relative overflow-hidden">
      {/* Accent glows */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#0877c5]/8 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#b51625]/6 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="w-full h-[4px] bg-gray-400/60 mb-12"></div>
        <div className="text-center mb-16">
          <p className="text-sm font-semibold tracking-widest uppercase text-[#0877c5] mb-3">Contato</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#0877c5] via-[#b51625] to-[#f3eb03] bg-clip-text text-transparent">
              Entre em Contato
            </span>
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Solicite um orçamento personalizado
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="space-y-8 text-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Vamos conversar sobre seu projeto?
              </h3>
              <p className="text-gray-600 leading-relaxed mb-8">
                Estamos prontos para transformar suas ideias em realidade. 
                Entre em contato e descubra como podemos ajudar você.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-[#0877c5] to-[#b51625] flex items-center justify-center text-white text-xl mb-3">
                  📞
                </div>
                <h4 className="font-bold text-gray-900 mb-1">Telefone</h4>
                <p className="text-gray-600">(11) 95903-4861</p>
              </div>

              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-[#b51625] to-[#f3eb03] flex items-center justify-center text-white text-xl mb-3">
                  📧
                </div>
                <h4 className="font-bold text-gray-900 mb-1">Email</h4>
                <p className="text-gray-600">art.custom10@gmail.com</p>
              </div>

              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-[#f3eb03] to-[#0877c5] flex items-center justify-center text-white text-xl mb-3">
                  📍
                </div>
                <h4 className="font-bold text-gray-900 mb-1">Endereço</h4>
                <p className="text-gray-600">Rua Miguel Franco de Araujo, 3 - São Paulo, SP</p>
              </div>
            </div>

            <div className="pt-8">
              <h4 className="font-bold text-gray-900 mb-4">Redes Sociais</h4>
              <div className="flex justify-center space-x-4">
                <a href="#" className="w-10 h-10 rounded-lg bg-[#0877c5]/10 border border-[#0877c5]/20 flex items-center justify-center hover:bg-[#0877c5] transition-colors">
                  <span className="text-lg">📘</span>
                </a>
                <a href="https://www.instagram.com/art.custom10?igsh=NzZ6cHZucGt2ZzYz&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-[#b51625]/10 border border-[#b51625]/20 flex items-center justify-center hover:bg-[#b51625] hover:text-white text-[#b51625] transition-colors" title="Siga-nos no Instagram">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                </a>
                <a href="https://www.tiktok.com/@art.custom10?_r=1&_t=ZS-94Ufczd0XiP" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-gray-900/10 border border-gray-900/20 flex items-center justify-center hover:bg-black hover:text-white text-gray-900 transition-colors" title="Siga-nos no TikTok">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.48V13a8.28 8.28 0 005.58 2.17v-3.48a4.85 4.85 0 01-3.77-1.23V6.69h3.77z"/></svg>
                </a>
                <WhatsAppLink
                  className="w-10 h-10 rounded-lg bg-green-500/10 border border-green-500/20 flex items-center justify-center hover:bg-green-500 transition-colors"
                  title="Fale conosco no WhatsApp"
                >
                  <span className="text-lg">💬</span>
                </WhatsAppLink>
              </div>
            </div>

            <div className="pt-4">
              <WhatsAppLink className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                <span>Falar no WhatsApp</span>
              </WhatsAppLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
